var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 28.594,
    viewBox: "0 0 30 28.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2af598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009efd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_settings",
    d: "M9.141,10.781a3.521,3.521,0,0,0-3.314,2.344H0v2.344H5.827a3.515,3.515,0,0,0,6.628,0H30V13.125H12.455A3.521,3.521,0,0,0,9.141,10.781Zm0,4.687A1.172,1.172,0,1,1,10.312,14.3,1.173,1.173,0,0,1,9.141,15.469ZM24.876,2.344a3.515,3.515,0,0,0-6.628,0H0V4.687H18.249a3.515,3.515,0,0,0,6.628,0H30V2.344ZM21.563,4.687a1.172,1.172,0,1,1,1.172-1.172A1.173,1.173,0,0,1,21.563,4.687ZM19.336,21.562a3.521,3.521,0,0,0-3.314,2.344H0V26.25H16.022a3.515,3.515,0,0,0,6.628,0H30V23.906H22.65A3.521,3.521,0,0,0,19.336,21.562Zm0,4.687a1.172,1.172,0,1,1,1.172-1.172A1.173,1.173,0,0,1,19.336,26.25Zm0,0",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.c4a115ff0a56a35c955f2a6cd0a11ee8.svg";
export { ForwardRef as ReactComponent };